import { useState } from 'react';

import SearchOverlaySuggestions from './SearchOverlaySuggestions';
import useSearch from '../../utils/hooks/useSearch';
import HamburgerOpen from '../../images/icons/hamburger-open.svg'

const SearchOverlay = ({isOpen, close}: SearchOverlayType) => {
  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const { data, isLoading } = useSearch(searchQuery, isFocused);


  return (
    <div className={`bg-blue z-20 h-screen w-screen lg:w-full absolute top-0 left-0 ${!isOpen ? 'hidden' : ''}`}>
      <form action="/buscar" autoComplete='off'>
        <button type="button" className="p-4 absolute top-8 right-8 cursor-pointer z-10" onClick={() => close()}>
          <HamburgerOpen className="cursor-pointer"/>
        </button>
        <div className="absolute top-1/3 px-4 lg:px-36 flex flex-col justify-center items-center w-full">
          <input
            className="text-gray-400 font-cirka border-b-2 border-primary pb-8 bg-transparent w-full z-10 text-3xl lg:text-9xl mb-8"
            type="text"
            placeholder="Search"
            name="q"
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuery(e.target.value)}
            />
          <SearchOverlaySuggestions suggestions={data} isLoading={isLoading} />
        </div>
      </form>
    </div>
  )
}

export default SearchOverlay

type SearchOverlayType = {
  isOpen: boolean,
  close: () => void
}
